import React from 'react'

const SVGBlur = () => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
    <defs>
      <filter id="blur">
        <feGaussianBlur in="SourceGraphic" stdDeviation="8,8"></feGaussianBlur>
      </filter>
    </defs>
  </svg>
)

export default SVGBlur;



// WEBPACK FOOTER //
// ./src/components/ui/images/SVGBlur.jsx